
export const custom = {
  styles: {
    code: {
      fontSize: 20
    }
  }
};
